import { useEffect, useState } from "react";
import AdminLayout from "@/components/admin/AdminLayout";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function AdminHomepage() {
  const [form, setForm] = useState(null);
  useEffect(() => { api.get("/homepage").then((r) => setForm(r.data)); }, []);

  const save = async () => {
    try {
      await api.put("/admin/homepage", form);
      toast.success("Homepage aggiornata — la vedrai subito nel sito");
    } catch (e) { toast.error("Errore"); }
  };

  if (!form) return <AdminLayout>Caricamento…</AdminLayout>;

  return (
    <AdminLayout>
      <div className="mb-6">
        <div className="font-mono-tech text-[10px] uppercase tracking-widest text-xd-muted">Contenuti</div>
        <h1 className="font-admin text-2xl font-bold">Contenuti Homepage</h1>
      </div>
      <div className="bg-white border border-xd-border rounded-xl p-6 max-w-2xl space-y-4">
        <div>
          <label className="text-xs font-semibold uppercase tracking-widest text-xd-muted font-mono-tech">Badge hero</label>
          <Input value={form.hero_badge} onChange={(e) => setForm({ ...form, hero_badge: e.target.value })} data-testid="hp-hero-badge" />
        </div>
        <div>
          <label className="text-xs font-semibold uppercase tracking-widest text-xd-muted font-mono-tech">Titolo hero</label>
          <Input value={form.hero_title} onChange={(e) => setForm({ ...form, hero_title: e.target.value })} data-testid="hp-hero-title" />
        </div>
        <div>
          <label className="text-xs font-semibold uppercase tracking-widest text-xd-muted font-mono-tech">Sottotitolo hero</label>
          <textarea rows={3} value={form.hero_subtitle} onChange={(e) => setForm({ ...form, hero_subtitle: e.target.value })} data-testid="hp-hero-subtitle" className="w-full border border-xd-border rounded-md px-3 py-2 text-sm" />
        </div>
        <div>
          <label className="text-xs font-semibold uppercase tracking-widest text-xd-muted font-mono-tech">Banner promozionale</label>
          <Input value={form.promo_banner} onChange={(e) => setForm({ ...form, promo_banner: e.target.value })} data-testid="hp-promo" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs font-semibold uppercase tracking-widest text-xd-muted font-mono-tech">CTA primaria</label>
            <Input value={form.cta_primary_label} onChange={(e) => setForm({ ...form, cta_primary_label: e.target.value })} />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-widest text-xd-muted font-mono-tech">CTA secondaria</label>
            <Input value={form.cta_secondary_label} onChange={(e) => setForm({ ...form, cta_secondary_label: e.target.value })} />
          </div>
        </div>
        <button type="button" onClick={save} data-testid="hp-save" className="btn-cta rounded-lg px-6 py-3 text-sm">Salva modifiche</button>
      </div>
    </AdminLayout>
  );
}
